import mori from 'mori';
import { appDefault } from '../../config/config';

/**
 * [filterByRow]
 * @TODO finish documenting this out
 * @param  {[type]} row          [description]
 * @param  {[type]} combined     [description]
 * @param  {[type]} shouldFilter [description]
 * @param  {[type]} withSummary  [description]
 * @return {[type]}              [description]
 */
export default function(row, combined, shouldFilter, withSummary) {
  return shouldFilter ?
    mori.some(
      (baseColumn) => mori.every(
        (selected) => mori.equals(
          mori.last(mori.first(selected)),
          mori.get(row, mori.first(mori.first(selected)))
        ) ||
        (
          mori.get(row, 'isSummary', false) &&
          withSummary &&
          mori.equals(
            mori.last(mori.first(mori.first(baseColumn)))
              .replace(appDefault.isSummaryRow, ''),
            mori.get(row, mori.first(mori.first(mori.first(baseColumn))))
          )
        ),
        baseColumn
      ),
      combined
    ) :
    row;
}



/** WEBPACK FOOTER **
 ** ../~/eslint-loader!./js/services/table/filterByRow.js
 **/